var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncoming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 18.25,
    stroke: "#2177FE",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7776 18.9424C9.8296 17.2893 9.37185 15.9395 9.09584 14.5712C8.68762 12.5476 9.62181 10.5708 11.1694 9.30947C11.8234 8.77638 12.5732 8.95852 12.96 9.6524L13.8332 11.2189C14.5253 12.4606 14.8713 13.0814 14.8027 13.7396C14.7341 14.3978 14.2674 14.9339 13.334 16.006L10.7776 18.9424ZM10.7776 18.9424C12.6965 22.2883 15.7078 25.3013 19.0576 27.2224M19.0576 27.2224C20.7107 28.1704 22.0605 28.6282 23.4288 28.9042C25.4524 29.3124 27.4292 28.3782 28.6905 26.8306C29.2236 26.1766 29.0415 25.4268 28.3476 25.04L26.7811 24.1668C25.5394 23.4747 24.9186 23.1287 24.2604 23.1973C23.6022 23.2659 23.0661 23.7326 21.994 24.666L19.0576 27.2224Z",
    stroke: "#2177FE",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2269 17.7731L27 11M20.2269 17.7731C20.7322 18.2784 23.1154 17.7834 23.8351 17.7731M20.2269 17.7731C19.7216 17.2678 20.2166 14.8846 20.2269 14.1649",
    stroke: "#2177FE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncoming);
export default __webpack_public_path__ + "static/media/Incoming.5dd41c024d65a20f12862a0b8df056a6.svg";
export { ForwardRef as ReactComponent };